var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap-404 container"},[_c('ng-image',{staticClass:"not-fine",attrs:{"src":_vm.notFineImg,"alt":"thumbnail"}}),_c('div',[_vm._v("很抱歉，页面不小心迷路了")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }